import React, { useEffect, useState } from 'react';
import _ from 'lodash';

import { CircularProgress, Grid } from '@material-ui/core';
import DocumentField from 'app/components/DocumentField';
import OtherDocuments from 'app/components/OtherDocuments';
import { setFiles } from 'app/store/slices/forms';
import { SERVICES_CODES } from 'app/config/services';
import { handleChangeFile, handleDeleteFile } from 'app/utils/forms/files';
import { Field } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { DOCUMENT_TYPES } from 'app/utils/constants';
import { STATUS_CODES } from 'app/config/status';

const Files = props => {
  const dispatch = useDispatch();

  const {
    open,
    request,
    surveyVehicle,
    classes,
    values,
    contextProps: { canEdit },
  } = props;

  const service = useSelector(state => state.services.details);
  const revisions = useSelector(state => state.revisions.revisions);
  const filesStore = useSelector(state => state.forms.files);

  const [loadingFile, setLoadingFile] = useState(true);
  const [idFile, setIdFile] = useState(null);
  const [idGdoc, setIdGdoc] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [loadingDocuments, setLoadingDocuments] = useState(true);
  const [othersDocuments, setOthersDocuments] = useState([]);
  const [uploading, setUpLoading] = useState(false);

  const [disableEditFile, setDisableEditFile] = useState(() => {
    return !canEdit;
  });

  useEffect(() => {
    const init = async () => {
      if (open) {
        setLoadingFile(true);
        if (surveyVehicle.documentos && surveyVehicle.documentos.length > 0) {
          const laudo = surveyVehicle.documentos.filter(
            doc => doc.cdTipoDocumento === DOCUMENT_TYPES.LAUDO_VISTORIA
          );
          if (laudo.length > 0) {
            setIdFile(laudo[0].idFile);
            setIdGdoc(laudo[0].idGdoc);
            setFileName(laudo[0].fileName);
          }
        }
        setLoadingFile(false);

        setLoadingDocuments(true);
        let docsOK = [];
        if (revisions && Object.keys(revisions).length > 0) {
          let lastKey = Object.keys(revisions).pop();
          const revision = revisions[lastKey];
          if (revision?.documentos && revision?.documentos.length > 0) {
            if (surveyVehicle.documentos && surveyVehicle.documentos.length > 0) {
              surveyVehicle.documentos.forEach(file => {
                const thisDocument = _.find(revision.documentos, ['idFile', file.idFile]);
                if (thisDocument?.boConformidade) {
                  docsOK.push(file.idFile);
                }
              });
            }
          }
        }
        if (surveyVehicle.documentos) {
          const othersDocuments = surveyVehicle.documentos
            .filter(doc => {
              return doc.cdTipoDocumento !== DOCUMENT_TYPES.LAUDO_VISTORIA;
            })
            .map(doc => {
              const t = { ...doc };
              t.canEdit = canEdit;
              if (canEdit && doc?.idFile) {
                t.canEdit = !docsOK.includes(doc.idFile);
              } else {
                if (!canEdit && service.cdServico === SERVICES_CODES.EXCLUSAO_VEICULOS) {
                  if (!request.situacao) {
                    // new request
                    t.canEdit = true;
                  } else {
                    t.canEdit =
                      request.situacao?.boEdicaoPortalExterno ||
                      request.cdSituacao === STATUS_CODES.EM_CONSTRUCAO;
                  }
                }
              }
              //PREFFIX
              if (surveyVehicle?.veiculo?.dePlaca && surveyVehicle?.veiculo?.dePlaca !== '') {
                t.dePlaca = surveyVehicle.veiculo.dePlaca;
              }
              return t;
            });
          setOthersDocuments(othersDocuments);
          await dispatch(setFiles(othersDocuments));
        }
        if (idFile && docsOK.includes(idFile)) {
          setDisableEditFile(true);
        }
        setLoadingDocuments(false);
      }
    };
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, surveyVehicle]);

  useEffect(() => {
    const init = () => {
      if (open) {
        setLoadingFile(true);
        if (surveyVehicle.documentos && surveyVehicle.documentos.length > 0) {
          const laudo = surveyVehicle.documentos.filter(
            doc => doc.cdTipoDocumento === DOCUMENT_TYPES.LAUDO_VISTORIA
          );
          if (laudo.length > 0) {
            setIdFile(laudo[0].idFile);
            setIdGdoc(laudo[0].idGdoc);
            setFileName(laudo[0].fileName);
          }
        }
        setLoadingFile(false);
      }
    };
    init();
  }, [open, surveyVehicle]);

  useEffect(() => {
    const init = () => {
      if (open) {
        const aditionalDocs = filesStore.filter(doc => {
          return doc.cdTipoDocumento === DOCUMENT_TYPES.OTHERS;
        });
        if (!values?.documentos) {
          values.documentos = [];
        }
        let formDocuments = [...values.documentos];
        if (aditionalDocs.length > 0) {
          aditionalDocs.forEach(doc => {
            const key = _.findKey(formDocuments, o => {
              return o.idFile === doc.idFile;
            });
            let t = { ...doc };
            if (key >= 0) {
              t = { ...formDocuments[key], ...doc };
              formDocuments[key] = t;
              return;
            }
            formDocuments.push(t);
          });
          values.documentos = formDocuments;
        }
      }
    };
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, filesStore]);

  return (
    <>
      <Grid item xs={12}>
        <h3 className={classes.subtitle}>Documentação</h3>
      </Grid>

      {loadingFile && (
        <div className={classes.loadingCRLV}>
          <CircularProgress size={16} />
        </div>
      )}
      {!loadingFile && (
        <Grid item xs={12} sm={6} md={4}>
          <Field
            value={fileName ? fileName : ''}
            required={false}
            name={fileName ? fileName : `Laudo-vistoria-${surveyVehicle?.veiculo?.dePlaca}`}
            label={'Laudo de vistoria'}
            id={DOCUMENT_TYPES.LAUDO_VISTORIA}
            disabled={disableEditFile}
            idGdoc={idGdoc}
            idFile={idFile}
            onChangeFile={doc => {
              handleChangeFile(doc, DOCUMENT_TYPES.LAUDO_VISTORIA, values);
              setUpLoading(false);
            }}
            onDeleteFile={idFile => handleDeleteFile(idFile, values)}
            uploading={uploading}
            setUpLoading={setUpLoading}
            component={DocumentField}
          />
        </Grid>
      )}

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <OtherDocuments
            {...props}
            type={'general'}
            title={'Anexos'}
            othersDocuments={othersDocuments}
            setOthersDocuments={setOthersDocuments}
            canEdit={canEdit}
            disableEditFile={!canEdit}
            loadingDocuments={loadingDocuments}
            setLoadingDocuments={setLoadingDocuments}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default Files;
